import { type RouteObject } from 'react-router'
import { fetchOssLicenses } from './oss-licenses'

/**
 * Creates routes for the legal feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: '/about',
      loader: ({ request }) => fetchOssLicenses(request.signal),
      lazy: {
        Component: () =>
          import('@/features/legal/AboutView/AboutViewContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
